<template>
    <div>
        <div v-loading="dlgLoading">
            <table class="row" >
                <tr v-for="(record, index) in records" :key="index">
                    <td style="width: 60px">{{record.name}}</td>
                    <td style="width: 250px; text-align: right" v-if="index != records.length - 1">{{record.remainUse}} * {{record.price}}{{record.loss? ' * ' + record.loss: ''}}</td>
                    <td style="width: 250px; text-align: right" v-if="index == records.length - 1">{{record.remainUse}}</td>
                    <td style="width: 20px">=</td>
                    <td style="width: 150px">{{record.remainAmount}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import { get } from "@/assets/common/request";

export default {
    name: "RemainAmountInfo",
    props: {
        meterId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            dlgLoading: true,
            records: [],
        }
    },
    methods: {
        loadData() {
            const url = 'meter/web/detail/onRemainAmount';
            this.dlgLoading = true;
            get(url, {meterId: this.meterId}).then(data => {
                const records = data.data;
                this.records = records;
            }).finally(() => {
                this.dlgLoading = false;
            });
        }
    },
    mounted() {
        if(this.meterId) {
            this.loadData();
        }

    }
}
</script>

<style scoped>
.row {
    margin: 10px 0px; 
    height: 18px;
    line-height: 20px;
    font-size: 14px;
    border: 1px solid #ccc;
}
.row td {
    margin: 10px 5px;
    padding: 5px;
    border: 1px solid #ccc;
    width: 180px
}
</style>